import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme, { isCompact }: { isCompact: boolean }) => ({
  userDetailContainer: {
    marginTop: isCompact ? 0 : theme.other.spacing._32,
    display: 'flex',
    flexFlow: isCompact ? 'row-nowrap' : 'column nowrap',
    alignItems: isCompact ? 'flex-start' : 'center',
    gap: isCompact ? theme.other.spacing._12 : theme.other.spacing._16,

    [`@media(min-width: ${theme.breakpoints.sm}px)`]: {
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
  },
  handleContainer: {
    display: 'flex',
    flexFlow: isCompact ? 'row-nowrap' : 'column nowrap',
    alignItems: isCompact ? 'flex-start' : 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._8,
    marginBottom: theme.other.spacing._8,

    [`@media(min-width: ${theme.breakpoints.sm}px)`]: {
      flexFlow: 'row nowrap',
      marginBottom: 0,
    },
  },
}));

export default useStyles;
